import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { PulseContent } from "./pulse";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/pulse")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () =>
    buildHead({
      locale: "es",
      title: "PULSE: Motor de Ejecución Shopify · Shugert",
      description:
        "PULSE es la capa de ejecución propietaria de Shugert. Cambios Shopify validados, previews en staging, cero riesgo en tu tienda en vivo.",
      path: "/es/pulse",
      altPath: alternatePath("/es/pulse", "en"),
      ogImage: "/og-pulse-es-v2.jpg",
      jsonLd: breadcrumbJsonLd([
        { name: "Inicio", path: "/es" },
        { name: "PULSE", path: "/es/pulse" },
      ]),
    }),
  component: () => (
    <SiteShell>
      <PulseContent locale="es" />
    </SiteShell>
  ),
});
